import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Grid, TablePagination, Typography } from '@mui/material';
import { getNotification } from 'redux/actions/UserNotification';
import Loader from 'components/loader/Loader';
import { isEmpty } from 'lodash';
import CommonNoDataFound from 'components/CommonNoDataFound/CommonNoDataFound';
import img from 'assets/images/companyLogo.svg';

export default function Notification() {
  const dispatch = useDispatch();
  const tableData = useSelector(
    (state) => state?.userNotification?.userNotification?.data
  );
  const loader = useSelector((state) => state?.userNotification?.loading);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const id = localStorage.getItem('ID');
  const filterData = {
    id: id,
    page: page,
    pageSize: rowsPerPage,
  };
  useEffect(() => {
    dispatch(getNotification(filterData));
  }, []);

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
    dispatch(getNotification({ ...filterData, page: newPage }));
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value));
    setPage(0);
    dispatch(
      getNotification({
        ...filterData,
        page: 0,
        pageSize: parseInt(event.target.value),
      })
    );
  };

  const startIndex = page * rowsPerPage;
  const endIndex = startIndex + rowsPerPage;

  return (
    <>
      <div className="mt30">
        {loader ? (
          <Loader />
        ) : (
          <Grid container className="mt20">
            {!isEmpty(tableData?.notification) ? (
              tableData &&
              tableData?.notification &&
              Object.keys(tableData?.notification)?.map((val, idx) => (
                <Grid
                  item
                  xs={12}
                  key={val}
                  className={`mb25 ${idx === 0 ? 'notifGrid' : 'padding20'}`}
                >
                  <div className="mb15 fw600 font20">{val}</div>
                  {tableData?.notification[val]?.map((val2, idx2) => (
                    <Grid
                      container
                      key={val2.id}
                      className={`justifyBetween mb15 ptb20 ${
                        idx2 < tableData?.notification[val]?.length - 1
                          ? 'dottedUnderLine'
                          : ''
                      }`}
                    >
                      <Grid className="notiImg">
                        <img
                          className="imgSizeNoti"
                          src={val2.img && val2?.img !== null ? val2.img : img}
                          alt=""
                        />
                        {!val2?.status && <div className="imgDot"></div>}
                      </Grid>
                      <Grid item xs={9} className="notiDescr">
                        <Typography variant={'body2'} className="pl10">
                          {val2.message}
                        </Typography>
                      </Grid>
                      <Grid item xs={2} className="notiDate justifyEnd">
                        <Typography
                          variant={'body2'}
                          className="colorGrey fw500"
                        >
                          {val2.time}
                        </Typography>
                      </Grid>
                    </Grid>
                  ))}
                </Grid>
              ))
            ) : (
              <Grid
                item
                display={'flex'}
                justifyContent={'center'}
                alignItems={'center'}
                className="width100 heightCalc100vh"
              >
                <CommonNoDataFound />
              </Grid>
            )}
          </Grid>
        )}

        {tableData?.notification && tableData?.totalCount > 10 && (
          <TablePagination
            rowsPerPageOptions={[10, 25, 50]}
            component="div"
            count={tableData?.totalCount}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        )}
      </div>
    </>
  );
}
